import Sidebar from "@components/Sidebar";
import { useChurchDataProvider } from "@data/ChurchDataProvider";
import { useMediaQuery } from "react-responsive";
import { Outlet } from "react-router-dom";

export default function Appv2() {
  const churchData = useChurchDataProvider();

  const isMobile = useMediaQuery({ query: `(max-width: 800px)` });

  return <div className="Appv2" style={{
    display: 'flex'
  }}>
    <Sidebar churchName={churchData.church?.attributes.name ?? ""} isMobile={isMobile} />
    <div style={{
      marginTop: isMobile ? '80px' : '0',
      width: '100%',
      // Clips like hidden, but without becoming a scroll container that never
      // scrolls, which would stop position: sticky working in any page.
      overflow: 'clip'
    }}>
      <Outlet />
    </div>
  </div>
}